import { Tab } from "../../../components/navigationTabs/types";

export const VIEW_SETTINGS_PERMISSION = "3476ece8-0485-4b7f-98b1-378199bf8767";

export const SETTINGS_TABS: Tab[] = [
  { tab: "Company", link: "company" },
  { tab: "Templates", link: "templates" },
  { tab: "Statuses", link: "statuses" },
  { tab: "Work Types", link: "work-types" },
  { tab: "Custom Fields", link: "custom-fields" },
  { tab: "Billing", link: "billing" },
  { tab: "Team", link: "team" },
  { tab: "Tags", link: "tags" },
  { tab: "Integrations", link: "integrations" },
];

/**
 * Settings > Subscription = ProCharted's own plan (owner 2026-10-25: not under Billing, which is about billing the
 * firm's clients). Only for people with "Manage subscription & payment" in a firm billed per user.
 */
export const SUBSCRIPTION_PATH = "/settings/subscription";

export const settingsTabs = (showSubscription: boolean): Tab[] =>
  showSubscription
    ? SETTINGS_TABS.flatMap((tab) =>
        tab.link === "billing"
          ? [tab, { tab: "Subscription", link: "subscription" }]
          : [tab],
      )
    : SETTINGS_TABS;
